package one.healthium.settings.ui.menu

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.mapLatest
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.settings.domain.SettingsMenuRepository
import one.healthium.ui.common.vm.BaseViewModel

class SettingsMenuViewModel(
    private val settingsMenuRepository: SettingsMenuRepository,
) : BaseViewModel() {

    private val _state = MutableStateFlow(SettingsMenuUiState())
    fun state(menuId: String): StateFlow<SettingsMenuUiState> {
        if (_state.value.menuId != menuId) {
            _state.update { state ->
                state.copy(
                    loading = true,
                    menuId = menuId,
                    menu = null,
                )
            }
        }
        return _state
    }

    init {
        _state
            .mapLatest { it.menuId }
            .filterNotNull()
            .distinctUntilChanged()
            .mapLatest { menuId ->
                try {
                    Result.success(settingsMenuRepository.getMenu(menuId))
                } catch (e: Exception) {
                    Result.failure(e)
                }
            }
            .onEach { result ->
                result
                    .onSuccess {
                        _state.update { state ->
                            state.copy(
                                loading = false,
                                menu = it
                            )
                        }
                    }
                    .onFailure {
                        // TODO show error
                        Logger.e("settings menu error", it)
                    }
            }
            .launch()
    }
}